module.exports = __webpack_public_path__ + "img/bg1.4cd66241.jpg";